module.exports = __webpack_public_path__ + "img/Apoint2.7b4d1d58.png";